// Short-code map for quest / guide-quest clearCondition keys.
// Keys are alphabetically ordered → numeric index (string-encoded for JSON
// object keys). Used as a `dict` field type in the codec.
//
// Add new keys to the END of the list, never reorder — values are persisted
// in R2 seed JSON.

export const CLEAR_CONDITION_CODE_MAP: Record<string, string> = {
  AD_WATCH: '0',
  CHARACTER_UPGRADE_COUNT: '1',
  LEAGUE_PLAY_COUNT: '2',
  PET_EQUIP: '3',
  PET_OWNED: '4',
  PET_SUMMON_COUNT: '5',
  PET_UPGRADE_COUNT: '6',
  STAGE_CLEAR: '7',
  STAGE_CLEAR_COUNT: '8',
  STAGE_PLAY_COUNT: '9',
  SUMMON_TYPE: '10',
  TOTAL_STAR_COUNT: '11',
  VALHALLA_PLAY_COUNT: '12',
  FOLKVANGR_PLAY_COUNT: '13',
};
